import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

import ErrorModal from "@/components/modals/error.vue"
  import {Payment as PaymentClient} from "@/endpoints/rutsolve/gql/resolvers/payment"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import {onBeforeMount, ref} from "vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import {PaymentRedirectInput} from "@/endpoints/rutsolve/gql/generated/graphql"
  import Button from "@/components/button.vue"
  import {useRoute} from "vue-router"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'pay',
  setup(__props) {

  const error = ref<Error>(null)
  const orderID = ref<string>(null)
  const paymentClient = new PaymentClient()

  onBeforeMount(() => {
    orderID.value = useRoute().params.orderID.toString()
  })

  async function payRedirect(method: string) {
    try {
      const failure = `${process.env.VUE_APP_RUTSOLVE_REST_PAYMENT}/buckaroo/failure/${orderID.value}`
      const success = `${process.env.VUE_APP_RUTSOLVE_REST_PAYMENT}/buckaroo/success/${orderID.value}`
      const input: PaymentRedirectInput = {
        method: method,
        orderID: orderID.value,
        pushFailure: failure,
        pushSuccess: success,
        returnURL: success,
        returnURLCancel: failure,
        returnURLError: failure,
        returnURLReject: failure
      }
      const url = await paymentClient.redirect(input)
      if (url) {
        window.location.replace(url)
      }
    } catch (e) {
      error.value = e
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createVNode(VerticalNavigator, null, {
        default: _withCtx(() => [
          _createVNode(Breadcrumb, {
            links: [{
          title: 'RutSolve',
          routeName: 'index'
        }],
            title: "Pay"
          }),
          _cache[4] || (_cache[4] = _createElementVNode("h1", null, " Pay ", -1)),
          _createElementVNode("table", null, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    alt: "iDeal",
                    src: require('@/images/ideal_logo.png')
                  }, null, 8, _hoisted_1)
                ]),
                _createElementVNode("td", null, [
                  _createVNode(Button, {
                    title: "Pay With iDeal",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (payRedirect('IDEAL')))
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    alt: "KBC",
                    src: require('@/images/kbc_logo.png')
                  }, null, 8, _hoisted_2)
                ]),
                _createElementVNode("td", null, [
                  _createVNode(Button, {
                    title: "Pay With KBC",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (payRedirect('KBC')))
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    alt: "PayPal",
                    src: require('@/images/paypal_logo.png')
                  }, null, 8, _hoisted_3)
                ]),
                _createElementVNode("td", null, [
                  _createVNode(Button, {
                    title: "Pay With PayPal",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (payRedirect('PAYPAL')))
                  })
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }),
      (error.value)
        ? (_openBlock(), _createBlock(ErrorModal, {
            key: 0,
            error: error.value,
            "onUpdate:error": _cache[3] || (_cache[3] = ($event: any) => ((error).value = $event))
          }, null, 8, ["error"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})